import axios from 'axios';
import config from '../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../core/modules/common/tools/URLTools';

const apiFetchComparativeBagUsage = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getBagUsageComp',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchComparativeBagUsage;
